import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PvPopover = PopoverPrimitive.Root;
